import React from "react";

export function PageHeader({ eyebrow, title, subtitle, actions, children }) {
  return (
    <div className="px-10 pt-10 pb-7 fade-up" data-testid="page-header" style={{ borderBottom: "1px solid var(--line)" }}>
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <div>
          {eyebrow && (
            <div className="flex items-center gap-2 mb-2">
              <span className="h-0.5 w-6" style={{ background: "var(--accent)" }} />
              <span className="eyebrow" style={{ color: "var(--accent)" }}>{eyebrow}</span>
            </div>
          )}
          <h1 className="wm text-[28px] tracking-tight font-extrabold" style={{ color: "var(--ink)" }}>{title}</h1>
          {subtitle && (
            <p className="mt-1.5 text-[13px] max-w-2xl" style={{ color: "var(--ink-soft)" }}>{subtitle}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export function Section({ title, action, children, className = "" }) {
  return (
    <section className={`px-10 py-7 fade-up delay-1 ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <h2 className="text-[15px] font-bold" style={{ color: "var(--ink)" }}>
              {title}
            </h2>
          )}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Empty({ icon: Icon, title, description, action }) {
  return (
    <div className="surface-1 px-8 py-14 text-center">
      {Icon && <Icon size={28} className="mx-auto mb-3" style={{ color: "var(--ink-muted)" }} />}
      <div className="text-[14px] font-semibold" style={{ color: "var(--ink)" }}>{title}</div>
      {description && <div className="text-[12px] mt-1" style={{ color: "var(--ink-muted)" }}>{description}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
